import React from "react";


const Radio = ({ label, checked, setValue }) => {


    return (<>
        <input type='radio' checked={checked} label={label} value={label} onChange={() => setValue(label)} />
    </>)

}

export default Radio